import { load as loadCollection } from '@glimja/storefront/pages/collections/paths';
import { redirect } from '@sveltejs/kit';
import { getLocaleFromUrl, getHomeUrl } from '@glimja/shared/utils';
import type { Load } from '@sveltejs/kit';

export const load: Load = async (event) => {
  try {
    // Try to load the collection data
    const data = await loadCollection(event as any);
    return data;
  } catch (err) {
    // Handle collection errors with redirect to homepage
    const { url } = event;
    const locale = getLocaleFromUrl(url);
    const homeUrl = getHomeUrl(locale);
    redirect(301, homeUrl);
  }
};
